import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { DownloadFile, Icon, toast } from '@livable/saas-react-components';
import { Button, Divider, Menu } from '@mui/material';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
// import FSEBillModal from 'src/components/resident/ResidentModal/MoveOutTab/FSEBillModal';
import { track, events } from 'src/configs/amplitude';
import { useStore } from 'src/stores';
import useStyles from './styles';
import { RESIDENCY_STATUS_KEY_VALUES } from 'src/constants/residency';

// ? i18n
export const ResidentMenu = observer(_ref => {
  var _params$row$finalStat, _params$row;
  let params = _ref.params,
    accountId = _ref.accountId,
    _ref$openTenantModal = _ref.openTenantModal,
    openTenantModal = _ref$openTenantModal === void 0 ? () => {} : _ref$openTenantModal,
    propertyId = _ref.propertyId,
    residencyId = _ref.residencyId,
    isNotVacant = _ref.isNotVacant,
    setMmodalTempData = _ref.setMmodalTempData;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const page = 'Residencies Page';
  const status = (_params$row$finalStat = params.row.finalStatement) === null || _params$row$finalStat === void 0 ? void 0 : _params$row$finalStat.status;
  const isFSEId = store.account.featureFlagsStore.isFinalStatementEstimationEnabled && params.row.finalStatement && params.row.finalStatement.fseId;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  const open = Boolean(anchorEl);
  const check = async () => {
    var _residencyOverviewRes;
    const residencyOverviewResp = await store.residencies.getResidencyOverviewByResidencyIdAsync.run({
      residencyId: residencyId
    });
    if (!residencyOverviewResp || !residencyOverviewResp.isSuccessful || !(residencyOverviewResp !== null && residencyOverviewResp !== void 0 && (_residencyOverviewRes = residencyOverviewResp.response) !== null && _residencyOverviewRes !== void 0 && _residencyOverviewRes.invitationFileId)) {
      toast('error', {
        body: ['Paper invitation not found']
      });
      return;
    }
    return residencyOverviewResp.response.invitationFileId;
  };
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const openTenantModalTab = tab => {
    openTenantModal(tab);
    setAnchorEl(null);
  };
  const handleFSEClick = () => {
    store.fse.setFSEBillModalData({
      accountId: params.row.accountId,
      residentName: params.row.fullname,
      residencyId,
      unitName: params.row.Unitname
    });
    store.fse.setFSEBillGeneralModalIsOpen(true);
    setAnchorEl(null);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    size: "small",
    className: classes.todoDropdown,
    id: "action-menu-trigger",
    "aria-controls": "action-menu",
    "aria-haspopup": "true",
    "aria-expanded": open ? 'true' : undefined,
    "aria-label": "resident menu",
    onClick: handleClick,
    state: open ? 'active' : undefined,
    'custom-attribute': '441-resident-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "dotdotdot"
  })), /*#__PURE__*/React.createElement(Menu, {
    type: "action-menu",
    id: "action-menu",
    MenuListProps: {
      'aria-labelledby': 'action-menu-trigger'
    },
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    elevation: 0,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, !isNotVacant && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: () => {
      setMmodalTempData({
        unitname: params.row.unitName,
        occupancy: params.row.occupancy,
        unitData: [params.row.unitData],
        rowData: params.row
      });
      store.residencies.showOccupancyUpdateModal(true);
      setAnchorEl(null);
      setTimeout(() => {
        document.getElementById('DGOccupancyUpdateModal').click();
      }, 0);
    },
    className: classes.lightTrigger,
    'custom-attribute': '442-resident-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "group"
  }), t('residencies_page.occupancy_change')), /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: () => {
      track(events.modalOpened('Enroll Resident'), {
        page
      });
      store.enrollResident.changeInUnitValue('unitId', params.row.id);
      setMmodalTempData({
        unitname: params.row.unitName,
        occupancy: params.row.occupancy,
        unitData: [params.row.unitData],
        rowData: params.row
      });
      store.residencies.showEnrollmentModal(true);
      setAnchorEl(null);
      setTimeout(() => {
        document.getElementById('DGEnrollmentModal').click();
      }, 0);
    },
    className: classes.lightTrigger,
    'custom-attribute': '443-resident-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "move-in"
  }), t('enrollment_modal.enroll_new_resident'))), isNotVacant && /*#__PURE__*/React.createElement("div", null, (params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.status) === RESIDENCY_STATUS_KEY_VALUES.Future && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: () => {
      var _params$row$unitData;
      setMmodalTempData({
        unitname: params.row.unitName,
        occupancy: (_params$row$unitData = params.row.unitData) === null || _params$row$unitData === void 0 ? void 0 : _params$row$unitData.occupancy,
        unitData: [params.row.unitData],
        rowData: params.row
      });
      store.residencies.showOccupancyUpdateModal(true);
      setAnchorEl(null);
      setTimeout(() => {
        document.getElementById('DGOccupancyUpdateModal').click();
      }, 0);
    },
    className: classes.lightTrigger,
    'custom-attribute': '787-resident-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "group"
  }), t('residencies_page.unit_occupancy_change')), /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement(Button, {
    target: "_blank",
    variant: "menuAction",
    component: RouterLink,
    to: "/resident_acount?id=".concat(residencyId, "&accountId=").concat(accountId, "&propertyId=").concat(propertyId),
    'custom-attribute': '444-resident-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "account-box"
  }), t('residencies_page.view_account_profile')), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: () => openTenantModalTab('livable-solution'),
    'custom-attribute': '445-resident-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "group"
  }), t('residencies_page.occupancy_change')), /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: () => openTenantModalTab('billing-settings'),
    'custom-attribute': '446-resident-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "coin"
  }), t('residencies_page.billing_settings')), localStorage.getItem('livable_demo_mode') !== 'Demo' && /*#__PURE__*/React.createElement(DownloadFile, {
    check: check,
    store: store,
    text: "enrollment_modal.export_paper_invitation",
    variant: "menuAction"
  }), isFSEId && status === 'ReadyForReview' && /*#__PURE__*/React.createElement(Button, {
    className: classes.lightTrigger,
    onClick: handleFSEClick,
    variant: "menuAction",
    'custom-attribute': '447-resident-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "paper-dollar"
  }), "Review and send final bill"), localStorage.getItem('livable_demo_mode') !== 'Demo' && /*#__PURE__*/React.createElement(Divider, null), localStorage.getItem('livable_demo_mode') !== 'Demo' && /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: () => openTenantModalTab('personal-details'),
    'custom-attribute': '448-resident-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }), t('residencies_page.edit_resident_details')))));
});
ResidentMenu.propTypes = {
  openTenantModal: PropTypes.func
};